export default "__VITE_ASSET__d31e1840__"